const snack = require('../snack/snack')
const chatActions = require('./chat-actions')
var scrimchatcontainer
let currentActiveUserId = null;

export function HTMLselect(entity, id, source, chatcontainerHTML, htmlQf) {

    scrimchatcontainer = document.getElementById('scrim_chat_container')

    loadchatcontainer(chatcontainerHTML)

    htmlQf.chatcontainerHTML = document.getElementById(id)

}

export function showLoading() {
    const loadingElem = document.getElementById('chat-loading')
    if (loadingElem) {
        loadingElem.classList.add('chat-loading-show')
        loadingElem.classList.remove('dn')
    }
}

export function hideLoading() {
    const loadingElem = document.getElementById('chat-loading')
    if (loadingElem) {
        loadingElem.classList.remove('chat-loading-show')
        loadingElem.classList.add('dn')
    }
}

export function setActiveUser(detail) {
    currentActiveUserId = detail.userId

    const titleElem = document.getElementById('chatTopTitle')
    if (titleElem) {
        titleElem.textContent = detail.name
    }

    const allUsers = document.querySelectorAll('.chat-left .chat-cont')

    allUsers.forEach(elem => elem.classList.remove('chat-cont-selected'))

    const activeUserElem = document.querySelector(`.chat-left .chat-cont[data-id="${detail.userId}"]`)
    if (activeUserElem) {
        activeUserElem.classList.add('chat-cont-selected')
    }
}

export function getCurrentUserId() {
    return currentActiveUserId
}

export function scrollToBottom() {
    const chatContainer = getActiveChatContainer()
    if (chatContainer) {
        setTimeout(() => {
            chatContainer.scrollTop = chatContainer.scrollHeight
        }, 10)
    }
}

export function getTextInput(detail) {
    const contInput = detail.ev.target.parentElement;
    const chatInputElem = contInput.querySelector('.chat_input');
    const text = chatInputElem.value.trim();

    const cleanValue = text.replace(/\s/g, '');

    if (cleanValue.length <= 0) {
        snack.start({ "act": "show", "id": "empty", "msg": "El input no debe estar vacio" })
    }

    clearTextInput();
    return text;
}

export function disableInput() {
    const inputContainer = document.querySelector('.chat-input')
    const inputElem = document.getElementById('chat-input')

    if (inputContainer) {
        inputContainer.classList.add('chat-input-disabled')
    }
    if (inputElem) {
        inputElem.disabled = true
        inputElem.value = ''
    }
}

export function enableInput() {
    const inputContainer = document.querySelector('.chat-input')
    const inputElem = document.getElementById('chat-input')

    if (inputContainer) {
        inputContainer.classList.remove('chat-input-disabled')
    }

    if (inputElem) {
        inputElem.disabled = false
        inputElem.focus()
    }
}

export function clearChat() {
    const chatContaineractive = getActiveChatContainer()
    clearTextInput()
    if (chatContaineractive) {
        chatContaineractive.innerHTML = ""
    }
}

export function getActiveChatContainer() {
    const cont = document.querySelector('#chat-container')
    if (!cont) return null

    const chatCont = cont.querySelector(".chat")
    const textChatCont = chatCont.querySelector(".chat-text")
    
    return textChatCont || null
}

export function setTextInput(question) {
    const cont = document.querySelector('#chat-container')
    if (!cont) return null
    const chatCont = cont.querySelector(".chat")
    const chatInputElem = chatCont.querySelector('.chat-input .chat_input');

    if (chatInputElem) {
        chatInputElem.value = question
    }
}

export function getTextInputFrequent(detail) {
    const contInput = detail.question;
    const text = contInput.trim();

    const cleanValue = text.replace(/\s/g, '');

    if (cleanValue.length <= 0) {
        snack.start({ "act": "show", "id": "empty", "msg": "El input no debe estar vacio" })
    }

    clearTextInput();
    return text;
}

export function clearTextInput() {
    const cont = document.querySelector('#chat-container')
    if (!cont) return null
    const chatCont = cont.querySelector(".chat")
    const chatInputElem = chatCont.querySelector('.chat-input .chat_input');
    if (chatInputElem) {
        chatInputElem.value = ""
    }
}

function loadchatcontainer(chatcontainerHTML) {
    const body = document.body
    body.insertAdjacentHTML("beforeend", chatcontainerHTML)
}

export function show(detail, htmlQf) {
    if (!scrimchatcontainer) scrimchatcontainer = document.getElementById('scrim_chat_container')

    htmlQf.chatcontainerHTML.classList.add('chat-container-show')
    scrimchatcontainer.classList.add('scrim-show')
}

export function hide(detail, htmlQf) {

    htmlQf.chatcontainerHTML.classList.add('chat-container-hide')
    scrimchatcontainer.classList.add('scrim-hide')

    chatActions.clearChat()

    remove(() => {
        htmlQf.chatcontainerHTML.classList.remove('chat-container-hide');
        htmlQf.chatcontainerHTML.classList.remove('chat-container-show');

        scrimchatcontainer.classList.remove('scrim-show')
        scrimchatcontainer.classList.remove('scrim-hide')
    })
}

function remove(callback) {
    setTimeout(() => { callback() }, 300)
}